module.exports = __webpack_public_path__ + "static/media/JP_RCH_EYELASHES04.313346e5.jpg";